export function markManagementOverviewChartReady(
    readyChartIds: Set<string>,
    chartId: string
): Set<string> {
    if (readyChartIds.has(chartId)) {
        return readyChartIds;
    }
    const next = new Set(readyChartIds);
    next.add(chartId);
    return next;
}
